import { Routes } from '@angular/router';
import { getRootComponentRoute } from '../util/routing-util';
import { ERRORS_ROUTE_DATA } from './errors-routes';

export const ERRORS_ROUTES: Routes = [
    getRootComponentRoute({
        path: `${ERRORS_ROUTE_DATA.BASE_PATH}${ERRORS_ROUTE_DATA.AUTHENTICATION_ERROR.PATH}`,
        loadComponent: () => import('./authentication-error/authentication-error.component'),
        title: ERRORS_ROUTE_DATA.AUTHENTICATION_ERROR.TITLE,
    }),
    getRootComponentRoute({
        path: `${ERRORS_ROUTE_DATA.BASE_PATH}${ERRORS_ROUTE_DATA.FORBIDDEN.PATH}`,
        loadComponent: () => import('./forbidden/forbidden.component'),
        title: ERRORS_ROUTE_DATA.FORBIDDEN.TITLE,
    }),
    getRootComponentRoute({
        path: `${ERRORS_ROUTE_DATA.BASE_PATH}${ERRORS_ROUTE_DATA.NOT_FOUND.PATH}`,
        loadComponent: () => import('./not-found/not-found.component'),
        title: ERRORS_ROUTE_DATA.NOT_FOUND.TITLE,
    }),
    getRootComponentRoute({
        path: `${ERRORS_ROUTE_DATA.BASE_PATH}${ERRORS_ROUTE_DATA.SERVER_ERROR.PATH}`,
        loadComponent: () => import('./server-error/server-error.component'),
        title: ERRORS_ROUTE_DATA.SERVER_ERROR.TITLE,
    }),
    getRootComponentRoute({
        path: `${ERRORS_ROUTE_DATA.BASE_PATH}${ERRORS_ROUTE_DATA.UNAUTHORIZED.PATH}`,
        loadComponent: () => import('./unauthorized/unauthorized.component'),
        title: ERRORS_ROUTE_DATA.UNAUTHORIZED.TITLE,
    }),
];
